import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';
import { M as METHOD_MODULE, C as CURRENT_MODULE } from './index2.js';
import { s as state } from './index3.js';
import { d as defineCustomElement$1 } from './button-base2.js';

import { baseCss } from './css.js';
const nlConfirmLogoutCss = baseCss;

const NlConfirmLogoutStyle0 = nlConfirmLogoutCss;

const NlConfirmLogout = /*@__PURE__*/ proxyCustomElement(class NlConfirmLogout extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.handleLogoutBanner = createEvent(this, "handleLogoutBanner", 7);
        this.handleBackUpModal = createEvent(this, "handleBackUpModal", 7);
        this.nlCloseModal = createEvent(this, "nlCloseModal", 7);
        this.titleModal = "Delete keys?";
        this.description = "Your profile keys are stored in this browser tab and will be deleted if you log out, and your profile will be inaccessible.";
    }
    handleLogout() {
        this.handleLogoutBanner.emit(METHOD_MODULE.LOGOUT);
        this.nlCloseModal.emit();
    }
    handleCancel() {
        this.nlCloseModal.emit();
    }
    handleBackUp() {
        state.path = [CURRENT_MODULE.IMPORT_FLOW];
    }
    render() {
        return (h("div", { key: 'fe605f38f9d0a440fe53e21f19288c41e4762c22', class: "p-4 overflow-y-auto" }, h("h1", { key: '84d14a59035515b2fd612d262400a038887a10d7', class: "nl-title font-bold text-center text-4xl" }, this.titleModal), h("p", { key: '83ef73271c76309561be95e0207f8130d75a161c', class: "nl-description font-light text-center text-lg pt-2 max-w-96 mx-auto" }, this.description), h("div", { key: 'fce0f132846beb95dd9e41357f5ab87be7229a56', class: "mt-3 ml-auto mr-auto w-60 flex flex-col gap-2" }, h("button-base", { key: 'c4fc722a7c98d84e797963ed7fe928164411b701', onClick: () => this.handleBackUp(), titleBtn: "Backup keys", theme: "lemonade" }), h("button-base", { key: '39df385a9a8dc3fcd74f4196d4191bc4a308a16d', onClick: () => this.handleLogout(), theme: "crab", titleBtn: "Logout and delete keys" }))));
    }
    static get style() { return NlConfirmLogoutStyle0; }
}, [0, "nl-confirm-logout", {
        "titleModal": [1, "title-modal"],
        "description": [1]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["nl-confirm-logout", "button-base"];
    components.forEach(tagName => { switch (tagName) {
        case "nl-confirm-logout":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, NlConfirmLogout);
            }
            break;
        case "button-base":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { NlConfirmLogout as N, defineCustomElement as d };

//# sourceMappingURL=nl-confirm-logout2.js.map